export const QUERY_OPERATING_INTENTION = 'operating_intention' as const;
